import * as PIXI from "pixi.js";
import {SymbolValues} from "./server/XwaysHoarder2Data";
import {XwaysHoarder2GameAssets} from "./XwaysHoarder2GameAssets";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

export class XwaysHoarder2Statics {


    public static WIN_COUNT_UP = {
        fontName: XwaysHoarder2GameAssets.WIN_COUNT_UP,
        fontSize: 56,
        tint: 0xffffff
    }

    static noWinTint: number = PIXI.utils.string2hex("#414655");

    public static stepDuration: number = 0.06;
    public static symbolWidth: number = 160;
    public static symbolHeight: number = 200;
    public static NR_OF_REELS = 6;
    static defaultGameAreaSize: number[] = [3, 3, 3, 3, 3, 3];

    public static reelStopDelay: number = 0.1;
    public static reelStopDelayFastSpin: number = XwaysHoarder2Statics.stepDuration;
    public static reelStopDelayQuickStop: number = XwaysHoarder2Statics.stepDuration * 0.5;
    public static SCATTER_ANTICIPATION_DELAY_NORMAL: number = 2;
    public static SCATTER_ANTICIPATION_DELAY_FAST: number = 1;

    public static defaultSymbolValues: SymbolValues = {
        "L1": {3: 6, 4: 8, 5: 16, 6: 30},
        "L2": {3: 5, 4: 7, 5: 14, 6: 25},
        "L3": {3: 4, 4: 6, 5: 12, 6: 22},
        "L4": {3: 4, 4: 6, 5: 12, 6: 21},
        "L5": {3: 4, 4: 6, 5: 12, 6: 20},
        "M1": {3: 15, 4: 40, 5: 80, 6: 150},
        "M2": {3: 10, 4: 15, 5: 40, 6: 75},
        "M3": {3: 9, 4: 12, 5: 30, 6: 50},
        "M4": {3: 8, 4: 11, 5: 25, 6: 40},
        "M5": {3: 7, 4: 10, 5: 20, 6: 35}
    }
    public static FREESPINS_WON = {
        fontName: XwaysHoarder2GameAssets.FS_INTRO_SPINS_COUNTUP,
        fontSize: 156,
        tint: 0xffffff
    }

    public static readonly KILL_SYM_LIST: string [][] = [
        ["M6", "L5"],
        ["M5", "L4"],
        ["M4", "L3"],
        ["M3", "L2"],
        ["M2", "L1"]
    ]


    public static TRANSITION_HEADING_STYLE = {
        fontFamily: OpenSans.FAMILY,
        fontSize: 38,
        fontWeight: FontWeight.BOLD,
        fill: "#790000",
        dropShadow: false,
    };

    public static OUTRO_TRANSITION_CONTENT_STYLE = {
        fontWeight: FontWeight.DEMI_BOLD,
        fontFamily: "Helvetica",
        align: "center",
        fill: ["#d3d3d3", "#9c9c9c"],
        fillGradientStops: [0.3, 0.7],
        fillGradientType: 0,
        fontSize: 30,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    }
    public static OUTRO_TRANSITION_CONTENT_STYLE2 = {
        fontWeight: FontWeight.BOLD,
        fontFamily: OpenSans.FAMILY,
        align: "center",
        fill: ["#d3d3d3", "#9c9c9c"],
        fillGradientStops: [0.5, 0.8],
        fillGradientType: 0,
        fontSize: 30,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    }
    public static OUTRO_TRANSITION_CONTENT_STYLE3 = {
        fontWeight: FontWeight.BOLD,
        fontFamily: OpenSans.FAMILY,
        align: "center",
        fill: ["#98b662", "#637d40"],
        fillGradientStops: [0.5, 0.8],
        fillGradientType: 0,
        fontSize: 30,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    }


    public static INTRO_TRANSITION_CONTENT_STYLE = {
        fontWeight: FontWeight.SEMI_BOLD,
        fontFamily: OpenSans.FAMILY,
        fill: ["#d3d3d3", "#9c9c9c"],
        fillGradientStops: [0.3, 0.7],
        fillGradientType: 0,
        fontSize: 32,
        align: "center",
        stroke: 0x000000,
        strokeThickness: 2,
        dropShadow: true,
        dropShadowAngle: 1,
        dropShadowBlur: 2,
        dropShadowDistance: 2,
        lineJoin: "round"
    }

    public static specialSymbols = ["SC", "SSC", "XN", "XS", "XW", "LT"];
    public static payingSymbols = ["M1", "M2", "M3", "M4", "M5", "M6", "L1", "L2", "L3", "L4", "L5"];

    public static previousReelsAfterCollapse: string[][];
}